/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AggregatesListingSettingsQueryVariables = {|
  listingSlug: string
|};
export type AggregatesListingSettingsQueryResponse = {|
  +me: ?{|
    +isAdmin: ?boolean
  |},
  +listing: ?{|
    +id: string,
    +isFavourite: boolean,
    +removed: boolean,
  |},
|};
export type AggregatesListingSettingsQuery = {|
  variables: AggregatesListingSettingsQueryVariables,
  response: AggregatesListingSettingsQueryResponse,
|};
*/


/*
query AggregatesListingSettingsQuery(
  $listingSlug: String!
) {
  me {
    isAdmin
    id
  }
  listing: aggregatesListingBySlug(slug: $listingSlug) {
    id
    isFavourite
    removed
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "listingSlug"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAdmin",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": "listing",
  "args": [
    {
      "kind": "Variable",
      "name": "slug",
      "variableName": "listingSlug"
    }
  ],
  "concreteType": "AggregatesListing",
  "kind": "LinkedField",
  "name": "aggregatesListingBySlug",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isFavourite",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "removed",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AggregatesListingSettingsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      (v3/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AggregatesListingSettingsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      (v3/*: any*/)
    ]
  },
  "params": {
    "cacheID": "46a3bc0b36a2b039c32525d0985cad1d",
    "id": null,
    "metadata": {},
    "name": "AggregatesListingSettingsQuery",
    "operationKind": "query",
    "text": "query AggregatesListingSettingsQuery(\n  $listingSlug: String!\n) {\n  me {\n    isAdmin\n    id\n  }\n  listing: aggregatesListingBySlug(slug: $listingSlug) {\n    id\n    isFavourite\n    removed\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e604398df6f5da9e5506de30d4cbe597';

export default node;
